import { render, staticRenderFns } from "./ExcessesView.vue?vue&type=template&id=2ac3632e&scoped=true&"
import script from "./ExcessesView.vue?vue&type=script&lang=js&"
export * from "./ExcessesView.vue?vue&type=script&lang=js&"
import style0 from "./ExcessesView.vue?vue&type=style&index=0&id=2ac3632e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3632e",
  null
  
)

export default component.exports